import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import AboutBoxImg1 from '../assets/images/about-us/img-2.png';
import AboutBoxImg2 from '../assets/images/about-us/img-3.png';
import AboutBoxImg3 from '../assets/images/about-us/img-4.png';
import smallLogo from '../assets/images/logo.png'

const AboutBox = () => {
   return (
    <section className="about-box common-padding">
      <Container>
        <Row className="align-items-stretch">
          <Col lg={8} md={12}>
            <div className="about-box-content">
              <h1 className="about-box-title d-flex align-items-center">
                <img className="ps-1 pe-2" src={smallLogo} alt="" /> is here for you,
              </h1>
              <p className="about-box-subtitle">Every step of the way</p>
              <p className="about-box-description">
                JamboBay is incredibly personal — and for most people, it's the biggest transaction they'll ever make.
              </p>
              <p className="about-box-description">
                JamboBay is built on a deep understanding of movers' needs and a motivation to help you accomplish your moving goals. Whether you start by requesting to connect with an agent or learn about your financing options, JamboBay works to understand your unique situation in order to connect you with a local JamboBay professional who can tailor their services to you, help you explore options, and be your advocate to win your next home.
              </p>
              <div className="about-box-images">
                <img className='br-tl-br' src={AboutBoxImg2} alt="Modern Villa" />
                <img className='br-tr-bl' src={AboutBoxImg3} alt="Modern Villa" />
              </div>
            </div>
          </Col>
          <Col lg={4} md={12}>
            <div className="about-box-image">
              <img className='br-tr-bl' src={AboutBoxImg1} alt="Real estate planning" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default AboutBox;